export default function EmptyState({
  icon = '🔍',
  title,
  subtitle,
  actionLabel,
  onAction,
}: {
  icon?: string;
  title: string;
  subtitle?: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center">
      <div className="text-4xl">{icon}</div>
      <div className="text-base font-medium text-white">{title}</div>
      {subtitle && <div className="text-sm text-white/50">{subtitle}</div>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-3 rounded-full bg-mlbb-accent px-4 py-2 text-sm font-medium text-white active:opacity-80"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
